import { AppDispatch, store } from '@src/core/store';

export const dispatch: AppDispatch = store.dispatch;

export const locale = 'pt';
export const url = 'http://widget.planne.com.br/';
export const key = '4d59d924-e2a3-4350-a363-128aa9a50a68';
